import _ from 'lodash';
import { cloneAccessors } from './cloneAccessors';

function FindParams(options) {
    if (_.isObject(options)) {
        _.assign(this, cloneAccessors(options));
        const has = key => key in options;
        if (has('orderBy') && has('orderDirection') || has('sort')) {
            if (has('sort')) {
                this.sort = options.sort;
            } else {
                this.sort = options.orderBy ? options.orderBy + '|' + options.orderDirection : null;
            }
        }
        if (has('search')) {
            this.searchQuery = options.search;
        }
        if (has('pageNumber')) {
            this.page = options.pageNumber;
        }
        if (has('pageSize')) {
            this.rpp = options.pageSize;
        }
    } else {
        this.searchQuery = options;
    }
}

function KeyParams(id, options, propName) {
    if (_.isObject(id)) {
        _.assign(this, cloneAccessors(id));
    } else {
        if (propName !== undefined) {
            this[propName] = id;
        } else {
            this['id'] = id;
        }
    }

    if (options !== undefined && _.isObject(options)) {
        _.assign(this, cloneAccessors(options));
    }
}

function findParams(options) {
    return new FindParams(options);
}

function getParams(id, options, propName) {
    return new KeyParams(id, options, propName);
}

function batchDeleteParams(data, idPropertyName = 'id') {
    let items = [];
    _.each(data, (item) => {
        if (_.isObject(item)) {
            items.push(item[idPropertyName]);
        }
    });

    return items;

}

export {
    findParams,
    getParams,
    batchDeleteParams
};
